/**
 * @Description 获取当前页面名称hook
 * @demo const {title: name} = usePageTitle();
 */

import UserInfoContext from '@/layout/context';
import { isArray } from '@lhb/func';
import { useContext } from 'react';

export function usePageTitle(oriPath?: string) {
  const path = oriPath || window?.location?.pathname;
  const { menuList } = useContext(UserInfoContext) || {};

  return isArray(menuList) ? (menuList.find((item) => item?.uri === path) || {}) : {};
}
